export default {
  label: 'Categoria',
  placeholder: 'Nenhum',
};
